module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_eyegames_m2.a74e674d4c6bb61b7e224d79d6a585c1.png";